import { useEffect, useMemo } from 'react';

import { useInboxStore } from '@/features/inbox/stores/useInbox.store';
import { MailboxInfo } from '@/features/inbox/types';
import { useApi } from '@/shared/api';

export const makeEmail = (mailbox?: MailboxInfo) => {
  return mailbox ? `${mailbox.username}@${mailbox.domain}` : '';
};

export const useInboxConfig = () => {
  const api = useApi();
  const inboxStore = useInboxStore();

  useEffect(() => {
    if (inboxStore.mailbox) {
      return;
    }

    const fetchMailboxes = async () => {
      const res = await api.mailServerGetMailboxes();
      if (res.data?.mailbox) {
        inboxStore.setMailbox(res.data?.mailbox);
      }

      inboxStore.setReady(true);
    };

    fetchMailboxes();
  }, []);

  return useMemo(
    () => ({
      ready: inboxStore.ready,
      emailInfo: inboxStore.mailbox,
    }),
    [inboxStore],
  );
};
